import { render, staticRenderFns } from "./FireElectricalCause.vue?vue&type=template&id=47a95cb5&scoped=true"
import script from "./FireElectricalCause.vue?vue&type=script&lang=ts"
export * from "./FireElectricalCause.vue?vue&type=script&lang=ts"
import style0 from "./FireElectricalCause.vue?vue&type=style&index=0&id=47a95cb5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a95cb5",
  null
  
)

export default component.exports